<div>
    <app-barchart [setOptions]="null" [value]="null">
    </app-barchart>
    <div class="centered">
        {{'Keine aktuellen Daten vorhanden'}}
    </div>
</div>
